export default __webpack_public_path__ + "static/right-arrow-e7224ac7bc04f950b98e6cc13f8ca127.png";